<template>
  <div class="card-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Card',
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  background: #ffffff;
  border: 1px solid rgba(177, 177, 177, 0.25);
  box-shadow: 0px 4px 16px 0px #0000000d;
  border-radius: 8px;
  padding: 24px;
}
</style>
